import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import apiClient from '../../../../services/api';

import { showProjectElements } from '../../../../store/actions/Store';
import { toggleMessageOpen } from '../../../../store/actions/Message';

import CustomDialog from '../../../partials/CustomDialog';
import VirtualTable from '../../../partials/VirtualTable';

export const getProductsFixturesRequest = (projectId, type = 'products') => {
    return apiClient.post(`/api/projects/${type}`, {
        id: projectId
    })
};

const columns = [
    { id: 'art_number', title: 'ArtNo', numeric: false },
    { id: 'description', title: 'Description', numeric: false,
        style: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', } },
    { id: 'quantity', title: 'Quantity', numeric: true },
    { id: 'width', title: 'Width', numeric: true },
    { id: 'height', title: 'Height', numeric: true },
    { id: 'depth', title: 'Depth', numeric: true },
];

const gridTemplate = '2fr 5fr 1fr 1fr 1fr 1fr';

export const ProductsFixtures = () => {
    const { t } = useTranslation();

    const [rows, setRows] = useState([]);
    const [fetching, setFetching] = useState(false);

    const selected = useSelector((state) => state.store.selectedStoreElement);
    const type = useSelector((state) => state.store.showElements);

    const dispatch = useDispatch();

    const open = !!selected && !!type;

    const projectId = selected ? selected.project_id : null;
    const projectName = selected ? selected.name : '';

    useEffect(() => {
        if (!!projectId && !!type) {
            setFetching(true);
            getProductsFixturesRequest(projectId, type).then(response => {
                dispatch(toggleMessageOpen(`Project ${type} loaded`, 'success'));
                if (response.data.success) {
                    const rows = response.data[type] || [];
                    const indexed = rows.map((r, i) => ({ ...r, index: i }));
                    setRows(indexed);
                } else {
                    dispatch(toggleMessageOpen(`Project ${type} loading error!`, 'error'));
                }
            }).catch((error) => {
                dispatch(toggleMessageOpen(`Project ${type} loading error!`, 'error'));
            }).finally(() => {
                setFetching(false);
            })
        } else {
            setRows([]);
        }
    }, [projectId, type]);// eslint-disable-line react-hooks/exhaustive-deps

    const handleClose = () => {
        dispatch(showProjectElements(null));
    };

    let title = null;
    switch(type) {
        case 'products':
            title = t('Products of');
            break;
        case 'fixtures':
            title = t('Fixtures of');
            break;
        default:
            title = t('Elements of');
    }
    title += ': ' + projectName;

    return (
        <CustomDialog
            fullWidth
            maxWidth="lg"
            scroll="paper"
            open={open}
            onClose={handleClose}
            title={title}
        >
            {!fetching && rows && (
                <VirtualTable rows={rows} columns={columns} filter gridTemplateColumns={gridTemplate} rowHeight={50} />
            )}
            {fetching && (
                <Typography>{t(`Loading project ${type}`)}...</Typography>
            )}
        </CustomDialog>
    );
};
